export namespace ConstantsTest {
  export const TABLINK = 'tablink';
  export const FORM = 'form';
}
